<template>
<div class="content-body tenant-settings">
    <!-- <div class="" style="background: red ;display: none"> -->
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="handleSearchConditionChange()" size="small">
          <el-form-item label="子公司" prop="subcompanyIdList">
            <el-select multiple  v-model="dataForm.subcompanyIdList"
                       @change="getSupCompanyList"
                       filterable
                       clearable
                       popper-class="fixed-dropdown"
                       collapse-tags
                       class="input-width">
              <el-option
                  v-for="item in supCompanyList"
                  :key="item.id"
                  :label="item.orgName"
                  :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审批单号:">
                <el-input size="small" v-model="dataForm.rfqAuditCode" placeholder="审批单号" clearable @blur="handleSearchConditionChange"></el-input>
            </el-form-item>
            <el-form-item label="审批名称:">
                <el-input size="small" v-model="dataForm.rfqAuditName" placeholder="审批名称" clearable @blur="handleSearchConditionChange"></el-input>
            </el-form-item>
            <el-form-item label="审批单状态:">
                <el-select size="small" v-model="dataForm.rfqAuditStatus" placeholder="请选择状态" clearable @change="handleSearchConditionChange">
                    <el-option v-for="item in AUDIT_STATUS" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
          <el-form-item label="审批单类型:">
            <el-select size="small" v-model="dataForm.rfqAuditType" placeholder="请选择类型" clearable @change="handleSearchConditionChange">
              <el-option v-for="item in AUDIT_TYPE" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="RFQ编码:">
                <el-input size="small" v-model="dataForm.rfqCode" placeholder="RFQ编码" clearable @blur="handleSearchConditionChange"></el-input>
            </el-form-item>
            <!-- <el-form-item label="车型:">
                <el-input size="small" v-model="dataForm.carType" placeholder="车型" clearable @blur="getDataList"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="定点供应商:">
                <el-input size="small" v-model="dataForm.supplierId" placeholder="定点供应商" clearable @blur="getDataList"></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="类型:">
                <el-select size="small" v-model="dataForm.orderType" placeholder="请选择类型" clearable @change="getDataList">
                    <el-option v-for="item in ORDER_TYPE" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item>
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <!-- <el-button size="small" v-if="isAuth('sourcing:audit:newbutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建审批单
                </el-button> -->
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-upload2">
                    导入项目
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :header-cell-style="{background:'#f5f5f5'}" border :data="dataList" row-key="id" size="mini" style="width: 100%;" :height="tableHeight">
                <el-table-column type="index" width="50" align="center" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="rfqCode" header-align="center" align="center" label="RFQ编码" width="150">
                </el-table-column>
                <el-table-column prop="rfqStatus" header-align="center" align="center" label="RFQ状态" width="150">
                    <template slot-scope="scope">
                        {{getRFQ_STATUS_VALUE(scope.row.rfqStatus)}}
                    </template>
                </el-table-column>
                <el-table-column prop="rfqAuditCode" header-align="center" align="left" label="审批单编码" width="150">
                </el-table-column>
                <el-table-column prop="rfqAuditName" header-align="center" align="left" label="审批单名称" width="200">
                </el-table-column>
                <!-- (新品 B点) -->
                <el-table-column prop="rfqAuditType" header-align="center" align="center" label="审批单类型" width="150">
                    <template slot-scope="scope">
                        {{getAuditValue(scope.row.rfqAuditType)}}
                    </template>
                </el-table-column>
              <el-table-column prop="supplyEngineer" header-align="center" align="center" label="采购工程师" width="100">
              </el-table-column>
                <el-table-column prop="rfqAuditStatus" header-align="center" align="center" label="审批单状态" width="150">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.rfqAuditStatus)">
                            {{scope.row.rfqAuditStatus}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="sourceType" header-align="center" align="center" label="寻源申请类型" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sourceType=='1'" >议标</span>
                        <span v-if="scope.row.sourceType=='0'" >招标</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="partCode" header-align="center" align="left" label="零件编码" width="150">
            </el-table-column>
            <el-table-column prop="partName" header-align="center" align="left" label="零件名称">
            </el-table-column> -->
                <!-- <el-table-column prop="supplierCount" header-align="center" align="right" label="定厂供应商数量" width="150">
                </el-table-column>-->
                <el-table-column prop="rfqAuditDate" header-align="center" align="center" label="审批时间" width="150">
                </el-table-column>
                <!-- <el-table-column prop="carType" header-align="center" align="left" label="车型" width="120">
            </el-table-column> -->
                <!-- <el-table-column prop="rfqSupplierName" header-align="center" align="left" label="定点供应商" width="120">
            </el-table-column> -->
                <!-- <el-table-column prop="partPrice" header-align="center" align="right" label="部件价格(RMB)" width="120">
            </el-table-column>
            <el-table-column prop="workingEquipmentMoney" header-align="center" align="right" label="工装投入(RMB)" width="120">
            </el-table-column>
            <el-table-column prop="amortizationMoney" header-align="center" align="right" label="摊销金额(RMB)" width="120">
            </el-table-column>
            <el-table-column prop="totalCost" header-align="center" align="right" label="全部成本(RMB)" width="120">
            </el-table-column>
            <el-table-column prop="targetCost" header-align="center" align="right" label="目标成本(RMB)" width="120">
            </el-table-column>
            <el-table-column prop="oneCarCost" header-align="center" align="right" label="单车用量(PC)" width="120">
            </el-table-column>
            <el-table-column prop="totalCarCost" header-align="center" align="right" label="单车全部成本(RMB)" width="150">
            </el-table-column> -->
                <el-table-column prop="pic" header-align="center" align="center" width="120" label="当前流程图示">
                    <template slot-scope="scope">
                        <el-link :disabled="scope.row.rfqAuditStatus === '流程结束' || scope.row.rfqAuditStatus === '已选定'" type="primary" style="font-size: 12px;" @click="viewDiagram(scope.row.workflowId)"><i class="el-icon-view" style="margin-right: 5px;"></i>查看</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="createBy" header-align="center" align="center" label="审批历史" width="120">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="doHistory(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="left" width="210" label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" v-if="isAuth('sourcing:audit:editbutton')" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            修改
                        </el-button>
                        <el-button type="text" v-if="isAuth('sourcing:audit:auditbutton')" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            审批
                        </el-button>
                        <el-button type="text" v-if="isAuth('sourcing:audit:deletebutton')" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button>
                        <el-button type="text" v-if="isAuth('sourcing:audit:editbutton')" size="small" @click="exportData(scope.row)" icon="el-icon-edit">
                            导出
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination
                class="fixed-pagination"
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSize"
                :total="totalPage"
                layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <audit-add-or-update v-if="auditAddOrUpdateVisible" ref="AuditAddOrUpdate" @refreshDataList="getDataList"></audit-add-or-update>

        <el-drawer title="审批履历" :visible.sync="drawer" :with-header="true">
            <div v-for="str in historyList" :key="str">
                <el-descriptions :title="str.executeTime">
                    <el-descriptions-item label="审批类型">{{str.taskName}}</el-descriptions-item>
                    <el-descriptions-item label="审批结果">{{str.executeName}}</el-descriptions-item>
                    <el-descriptions-item label="原因" v-if="str.executeName == '不同意'">{{rejectReason}}</el-descriptions-item>
                </el-descriptions>
                <el-divider></el-divider>
            </div>
        </el-drawer>

        <el-dialog :visible.sync="showViewer" width="80%" title="流程图">
            <el-image :src="diagramUrl" style="margin-bottom: 120px;">
            </el-image>
        </el-dialog>

      <el-dialog :visible.sync="showWorkflowDialog" width="70%" title="审批进度" :close-on-click-modal="false">
        <div class="workflow-container">
          <div class="workflow-steps">
            <!-- 节点 1: 提交审批单 -->
            <div class="step" :class="getStepClass(1)">
              <div class="step-circle">1</div>
              <div class="step-label">提交审批单</div>
              <div class="step-status">{{ getStepStatusText(1) }}</div>
            </div>

            <!-- 连线 1→2 -->
            <div class="step-line" :class="getLineClass(1, 2)"></div>

            <!-- 节点 2: 采购科长审批 -->
            <div class="step" :class="getStepClass(2)">
              <div class="step-circle">2</div>
              <div class="step-label">采购科长审批</div>
              <div class="step-status">{{ getStepStatusText(2) }}</div>
            </div>

            <!-- 连线 2→3 -->
            <div class="step-line" :class="getLineClass(2, 3)"></div>

            <!-- 节点 3: 采购部长审批 -->
            <div class="step" :class="getStepClass(3)">
              <div class="step-circle">3</div>
              <div class="step-label">采购部长审批</div>
              <div class="step-status">{{ getStepStatusText(3) }}</div>
            </div>

            <!-- 连线 3→4 -->
            <div class="step-line" :class="getLineClass(3, 4)"></div>

            <!-- 节点 4: 采购总监审批 -->
            <div class="step" :class="getStepClass(4)">
              <div class="step-circle">4</div>
              <div class="step-label">采购总监审批</div>
              <div class="step-status">{{ getStepStatusText(4) }}</div>
            </div>
          </div>

          <!-- 当前状态说明 -->
          <div class="current-status">
            <h4>当前状态：{{ getCurrentStatusText() }}</h4>
            <p>{{ getCurrentStatusDesc() }}</p>
          </div>
        </div>
      </el-dialog>
    </div>
</div>
</template>

<script>
import {
    getAuditList,
    deleteAudit,
    exportNewAudit,
    exportAudit
    // list
} from '@/controller/audit'
import {
    getRFQDetail
    // list
} from '@/controller/rfq'
import {
    listAllStatus,
    getProcessDiagramCurrent,
    listCommentHistory
} from '@/controller/workflow'
import {
    getLabelByValue,
    AUDIT_STATUS,
    AUDIT_TYPE,
    getAuditValue,
    getRFQ_STATUS_VALUE,
    getTechnicalValue
} from '@/utils/const'

import AuditAddOrUpdate from './audit-add-or-update'
import {supCompanyList} from "../../../../controller/sys";
export default {
    data() {
        return {
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                rfqAuditStatus:'',
                rfqAuditType:'',
                rfqAuditCode: '',
                carType: '',
                supplierId: '',
                subcompanyIdList:[],
            },
            supCompanyList: [],
            getLabelByValue: getLabelByValue,
            getAuditValue: getAuditValue,
            getRFQ_STATUS_VALUE: getRFQ_STATUS_VALUE,
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 1000000,
            dataListLoading: false,
            dataListSelections: [],
            auditAddOrUpdateVisible: false,
            // 审批历史
            drawer: false,
            // 审批列表
            historyList: [],
            showViewer: false,
            diagramUrl: '',
            rejectReason: '',
            AUDIT_STATUS: AUDIT_STATUS,
            AUDIT_TYPE:AUDIT_TYPE,
          // 新增：工作流相关
          showWorkflowDialog: false,  // 控制工作流对话框显示
          currentWorkflowStatus: '', // 当前审批状态
          workflowSteps: [
            { step: 1, name: '提交审批单', status: '' },
            { step: 2, name: '采购科长审批', status: '' },
            { step: 3, name: '采购部长审批', status: '' },
            { step: 4, name: '采购总监审批', status: '' }
          ],
          statusPriority: {
            '提交审批单': 1,
            '采购科长审批': 2,
            '采购部长审批': 3,
            '采购总监审批': 4,
            '流程结束': 5,
            '已选定': 6,
            '已拟定价格协议': 7
          }
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 220
            }
        }
    },

    components: {
        AuditAddOrUpdate
    },
    activated() {
        this.getSupCompanyList()
    },
    methods: {
      handleSearchConditionChange() {
        this.getDataList("search");
      },
      //获取子公司列表
      getSupCompanyList(){
        supCompanyList().then(res=>{
          if(res && res.code == '00'){
            this.supCompanyList = res.body;
            // 若未选择子公司，则默认选中所有/第一个子公司
            if (!this.dataForm.subcompanyIdList.length) {
              this.dataForm.subcompanyIdList = res.body.map(item => item.id); // 默认全选
              // 或者只选第一个：this.dataForm.subcompanyIdList = [res.body[0]?.id];
            }
            this.getDataList("search");
          }
        })
      },
        // 获取数据列表
        getDataList(reason) {
          if (reason === "search") {
            this.pageIndex = 1;
          }
            this.dataListLoading = true
            getAuditList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                ...this.dataForm
                // 'partCode': this.dataForm.partCode,
                // 'partName': this.dataForm.partName,
                // 'carType':this.dataForm.carType,
                // 'supplierId':this.dataForm.supplierId,
                // 'partPrice':this.dataForm.partPrice,
                // 'workingEquipmentMoney':this.dataForm.workingEquipmentMoney,
                // 'amortizationMoney':this.dataForm.amortizationMoney,
                // 'totalCost':this.dataForm.totalCost,
                // 'targetCost':this.dataForm.targetCost,
                // 'oneCarCost':this.dataForm.oneCarCost,
                // 'totalCarCost':this.dataForm.totalCarCost,
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    for(let key in this.dataList){
                         if(this.dataList[key].technicalId != null) {
                             getRFQDetail({}, this.dataList[key].rfqId).then((data) => {
                                if (data && data.code === "00") {
                                    this.dataList[key].sourceType = data.body.sourceType;
                                }
                            })
                        }
                    }
                    console.log("totalPage", data.body.total)
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
                this.dataListLoading = false
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            //this.pageIndex = 1
            this.getDataList("pagination");
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList("pagination");
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            this.auditAddOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.AuditAddOrUpdate.init(row, row ? row.id : null, 'view')
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {
            // console.log(row, '新建')
            this.auditAddOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.AuditAddOrUpdate.init(row, row ? row.id : null, 'edit')
            })
        },
        // 删除
        deleteHandle(id) {
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                debugger
                deleteAudit({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        // 审批历史
        doHistory(row) {
            this.historyList = []
            this.rejectReason = row.unQuoteReason
            listCommentHistory({
                'workflowId': row.workflowId
            }).then(data => {
                if (data && data.code === '00') {
                    this.historyList = data.body
                } else {
                    this.$message.error(data.msg)
                }
            })
            this.drawer = true

        },
        viewDiagram(id) {
          const currentRow = this.dataList.find(item => item.workflowId === id);
          if (currentRow) {
            this.currentWorkflowStatus = currentRow.rfqAuditStatus;
            this.showWorkflowDialog = true;
          } else {
            // 如果找不到对应行，调用原来的接口（兼容旧功能）
            getProcessDiagramCurrent({
              id: id
            }).then(data => {
              this.diagramUrl = data.body;
              this.showViewer = true;
            })
          }
        },
      getStepClass(step) {
        const status = this.getStepStatus(step);
        return {
          'step-completed': status === 'completed',
          'step-current': status === 'current',
          'step-pending': status === 'pending'
        };
      },
      // 获取连线样式类
      getLineClass(fromStep, toStep) {
        const fromStatus = this.getStepStatus(fromStep);
        const toStatus = this.getStepStatus(toStep);

        // 如果前一个节点已完成，连线显示为完成状态
        if (fromStatus === 'completed' && (toStatus === 'current' || toStatus === 'completed')) {
          return 'line-completed';
        }
        // 如果前一个节点是进行中，且后一个节点是当前节点
        else if (fromStatus === 'current' && toStatus === 'current') {
          return 'line-active';
        }
        return 'line-pending';
      },

      // 获取步骤状态
      getStepStatus(step) {
        const status = this.currentWorkflowStatus;
        const priority = this.statusPriority[status] || 0;

        // 定义各状态的预期流程
        const statusSequence = [
          { step: 1, name: '提交审批单', requiredStatus: '提交审批单' },
          { step: 2, name: '采购科长审批', requiredStatus: '采购科长审批' },
          { step: 3, name: '采购部长审批', requiredStatus: '采购部长审批' },
          { step: 4, name: '采购总监审批', requiredStatus: '采购总监审批' }
        ];

        // 找到当前步骤对应的配置
        const currentStepConfig = statusSequence.find(s => s.step === step);
        if (!currentStepConfig) return 'pending';

        // 如果当前状态等于该步骤的状态，则为进行中
        if (status  === currentStepConfig.requiredStatus) {
          return 'current';
        }

        // 如果当前状态优先级高于该步骤的状态，则为已完成
        if (priority > this.statusPriority[currentStepConfig.requiredStatus]) {
          return 'completed';
        }

        // 否则为待处理
        return 'pending';
      },

      // 获取步骤状态文本
      getStepStatusText(step) {
        const status = this.getStepStatus(step);
        switch (status) {
          case 'completed':
            return '✓ 已完成';
          case 'current':
            return '▶ 进行中';
          case 'pending':
            return '○ 待处理';
          default:
            return '';
        }
      },

      // 获取当前状态文本
      getCurrentStatusText() {
        const statusMap = {
          '提交审批单': '草稿状态',
          '采购科长审批': '等待采购科长审批',
          '采购部长审批': '等待采购部长审批',
          '采购总监审批': '等待采购总监审批',
          '流程结束': '流程已完成',
        };
        return statusMap[this.currentWorkflowStatus] || this.currentWorkflowStatus;
      },

      // 获取当前状态描述
      getCurrentStatusDesc() {
        const descMap = {
          '提交审批单': '审批单已创建，等待提交',
          '采购科长审批': '采购科长正在审核审批单内容',
          '采购部长审批': '采购科长已审批通过，等待采购部长审批',
          '采购总监审批': '采购部长已审批通过，等待采购总监审批',
          '流程结束': '所有审批环节已完成，审批单生效',
        };
        return descMap[this.currentWorkflowStatus] || '暂无状态描述';
      },
        rfqAuditStatusFormat: function (value) {
            if (!value) {
                return ''
            }
            return getLabelByValue(AUDIT_STATUS, value)
        },

        exportData(rec) {
            exportNewAudit(rec).then(data => {
                if (data && data.code === '00') {

                    console.log(data)
                    this.readAsBinaryString(data.body)
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            // this.getDataList()
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        readAsBinaryString(data) {
           // alert(JSON.stringify(data))
            // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
            // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const blob = this.str2Blob(data.content, 'application/vnd.ms-excel;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
            let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
            dom.style.display = 'none';
            dom.href = url;
            dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
            document.body.appendChild(dom);
            dom.click();
        },
        str2Blob(str, mime) {
            var arr = str.split(',')
            var bstr = atob(arr[0]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            });
        },
        getStatusClass(status) {
            let className = ''
            switch (status) {
                case '草稿':
                    className = "text-primary"
                    break;
                default:
                    className = 'text-success'
                    break;
            }
            return className
        },
    }
}
</script>
<style scoped>
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  right: 50px; /* 距离右侧50px */
  background: white;
  padding: 10px 20px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}
/* 工作流样式 */
.workflow-container {
  padding: 20px;
}

.workflow-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 40px 0;
  padding: 0 20px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  min-width: 120px;
}

.step-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #e4e7ed;
  color: #606266;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  border: 3px solid #e4e7ed;
  transition: all 0.3s ease;
  margin-bottom: 10px;
}

.step-label {
  font-size: 14px;
  color: #303133;
  text-align: center;
  font-weight: 500;
  margin-bottom: 5px;
}

.step-status {
  font-size: 12px;
  color: #909399;
  text-align: center;
}

/* 步骤状态样式 */
.step-completed .step-circle {
  background: #67c23a;
  color: white;
  border-color: #67c23a;
}

.step-current .step-circle {
  background: #409eff;
  color: white;
  border-color: #409eff;
  animation: pulse 2s infinite;
}

.step-pending .step-circle {
  background: #e4e7ed;
  color: #606266;
  border-color: #e4e7ed;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(64, 158, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(64, 158, 255, 0);
  }
}

/* 连线样式 */
.step-line {
  flex: 1;
  height: 4px;
  background: #e4e7ed;
  margin: 0 10px;
  position: relative;
  top: -22px;
  transition: all 0.3s ease;
}

.line-completed {
  background: #67c23a;
}

.line-active {
  background: linear-gradient(90deg, #67c23a 0%, #409eff 100%);
}

.line-pending {
  background: #e4e7ed;
}

/* 当前状态说明 */
.current-status {
  margin-top: 40px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 8px;
  border-left: 4px solid #409eff;
}

.current-status h4 {
  margin: 0 0 10px 0;
  color: #303133;
  font-size: 16px;
}

.current-status p {
  margin: 0;
  color: #606266;
  line-height: 1.6;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .workflow-steps {
    flex-direction: column;
    gap: 30px;
  }

  .step-line {
    width: 4px;
    height: 40px;
    margin: 10px 0;
    top: 0;
  }
}
.step-label {
  font-size: 14px;
  color: #303133;
  text-align: center;
  font-weight: 500;
  margin-bottom: 5px;
  padding: 0 5px; /* 增加内边距防止文字溢出 */
}

/* 为采购总监审批节点添加特殊样式 */
.step-completed.step-4 .step-circle {
  background: #67c23a !important;
  color: white !important;
  border-color: #67c23a !important;
}

.step-current.step-4 .step-circle {
  background: #409eff !important;
  color: white !important;
  border-color: #409eff !important;
}
</style>
